(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('editMaquina', EditMaquinaDirective);

  function EditMaquinaDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/cadastros/maquinas/edit.html',
      controller: 'MaquinaEditCtrl',
      controllerAs: 'edit',
      scope: {
        maquina: '<',
        groups: '<'
      },
      bindToController: true
    };
  }
}());
